import { useHandleSignInCallback } from "@logto/react";
import { useNavigate } from "react-router-dom";

import PageLoader from "@/components/molecules/PageLoader";

const Callback = () => {
  const navigate = useNavigate();

  useHandleSignInCallback(() => {
    navigate("/");
  });

  return <PageLoader />;
};

export default Callback;
